/**
 * @private
 * @class
 * A query definition
 * */
export default function Query(){
  this.queryString = null;
  this.hasTarget = null;
  this.target = null;
  this.geometry = null;
  this.limit = null;
  this.timeout = null;
  this.type = null;
};

Query.Builder = function(){
  return new QueryBuilder();
};

/**
 * Tests whether two Query objects contain the same query data
 * @param {Query} testQuery
 */

Query.prototype.equals = function(testQuery){
  //noinspection RedundantIfStatementJS
  if (this.queryString == testQuery.queryString && this.target == testQuery.target && this.limit == testQuery.limit && this.timeout == testQuery.timeout){
    //TODO: Test whether geometries are equal
    return true;
  } else{
    return false;
  }
};

/**
 * Builder of Query objects
 * Query objects MUST be built using this builder 
 * @private
 * 
 * @constructor
 * */
function QueryBuilder(){
  this._queryString = "";
  this._geometry = null;
  this._limit = null;
  this._timeout = 10000;
  this._type = null;
  this._target = null;
}

QueryBuilder.prototype.copy = function(query){
  this._queryString = query.queryString;
  this._geometry = query.geometry;
  this._limit = query.limit;
  this._timeout = query.timeout;
  this._type = query.type;
  this._target = query.target;
  return this;
};

QueryBuilder.prototype.build = function(){
  if (this._limit === null || this._type === null){
    throw "Invalid Query parameters";
  }
  const newQuery = new Query();
  if (this._target){
    newQuery.hasTarget = true;
    newQuery.target = this._target;
  }else{
    newQuery.hasTarget = false;
  }
  newQuery.queryString = this._queryString.trim();
  newQuery.geometry = this._geometry;
  newQuery.limit = this._limit;
  newQuery.timeout = this._timeout;
  newQuery.type = this._type;
  return newQuery;
};

QueryBuilder.prototype.queryString = function(queryString){
  this._queryString = queryString;
  return this;
};

QueryBuilder.prototype.geometry = function(geometry){
  this._geometry = geometry;
  return this;
};

QueryBuilder.prototype.limit = function(limit){
  this._limit = limit;
  return this;
};

QueryBuilder.prototype.timeout = function(timeout){
  this._timeout = timeout;
  return this;
};

QueryBuilder.prototype.type = function(type){
  this._type = type;
  return this;
};

QueryBuilder.prototype.target = function(target){
  this._target = target;
  return this;
};

